<script>
	import Helper from '../Models/Helper';
	import Router from '../States/Router';
	import Agent from '../States/Agent';
	import Sidebar from './Sidebar.svelte';

	let loading = true;
	Helper.cardLoading('.card-disabled', true);
	function getTimelineIcon(type) {
		return type == 'incoming' ? 'uil-incoming-call' : 'uil-outgoing-call';
	}

	function getTimelineColor(type) {
		return type == 'unanswered' ? 'danger' : 'success';
	}

	function goToConference(conferenceId, contactId) {
		if(contactId)
			Router.component('conference', {id: conferenceId, contactId, show: true});
	}

	function goToContact(contactId) {
		if(contactId)
			Router.component('contact', {id: contactId});
	}

	async function init() {
		await Agent.getSelf();
		Helper.cardLoading('.card-disabled', false);
	}

	init();
</script>

<style>
	#recent-contacts .round-name {
		float: left;
		margin-right: .9em;
	}

	#recent-contacts .forward-button i {
		font-size: 1.4em;
	}

	#recent-contacts .inbox-item, .timeline-item-info {
		cursor: pointer;
	}

	div[data-simplebar] {
		height: 44.5em;
	}

	.capitalize {
		text-transform: capitalize;
	}
</style>

<div class="container-fluid">
	<div class="wrapper">
		<Sidebar/>
		<div class="content-page">
			<div class="content">
				<div class="row">
					<div class="col-12">
						<div class="page-title-box">
							<h4 class="page-title">Dashboard</h4>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-lg-4 col-md-6">
						<div class="card">
							<div class="card-body">
								<h4 class="header-title mb-3">Global Timeline</h4>
								<div data-simplebar="">
									<div class="timeline-alt pb-0">
										{#each $Agent.globalTimeline as item}
											<div class="timeline-item">
												<i class="uil {getTimelineIcon(item.type)} bg-{getTimelineColor(item.type)}-lighten text-{getTimelineColor(item.type)} timeline-icon"></i>
												<div class="timeline-item-info" on:click={() => goToConference(item.conferenceId, item.contactId)}>
													<div class="text-{getTimelineColor(item.type)} fw-bold mb-1 d-block">{item.contactName}</div>
													<small>{item.description}</small>
													<p class="mb-0 pb-2">
														<small class="text-muted">{item.dateTime}</small>
													</p>
												</div>
											</div>
										{/each}
									</div>
								</div>
							</div>
							{#if loading}
								<div class="card-disabled"><div class="card-portlets-loader"></div></div>
							{/if}
						</div>
					</div>
					<div class="col-lg-4 col-md-6">
						<div class="card">
							<div class="card-body">
								<h4 class="header-title mb-3">Personal Timeline</h4>
								<div data-simplebar="">
									<div class="timeline-alt pb-0">
										{#each $Agent.timeline as item}
											<div class="timeline-item">
												<i class="uil {getTimelineIcon(item.type)} bg-{getTimelineColor(item.type)}-lighten text-{getTimelineColor(item.type)} timeline-icon"></i>
												<div class="timeline-item-info" on:click={() => goToConference(item.conferenceId, item.contactId)}>
													<div class="text-{getTimelineColor(item.type)} fw-bold mb-1 d-block">{item?.contactName ?  item.contactName : item?.agentName}</div>
													<small class="capitalize">{item.title}</small>
													<p class="mb-0 pb-2">
														<small class="text-muted">{item.dateTime}</small>
													</p>
												</div>
											</div>
										{/each}
									</div>
								</div>
							</div>
							<div class="card-disabled"><div class="card-portlets-loader"></div></div>
						</div>
					</div>
					<div id="recent-contacts" class="col-lg-4 col-md-6">
						<div class="card">
							<div class="card-body">
								<h4 class="header-title mb-3">Recent Contacts</h4>
								<div class="inbox-widget">
									{#each $Agent.recentContacts as contact}
										<div class="inbox-item" on:click={() => goToContact(contact.id)}>
											<div class="round-name">{contact.initials}</div>
											<p class="inbox-item-author">{contact.name}</p>
											{#if contact.company}
												<p class="inbox-item-text">{contact.company}</p>
											{/if}
											<div class="inbox-item-date">
												<!-- <div class="btn btn-sm btn-link forward-button"><i class="uil-outgoing-call"></i> </div> -->
											</div>
										</div>
									{/each}
								</div>
							</div>
							<div class="card-disabled"><div class="card-portlets-loader"></div></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>